module.exports = __webpack_public_path__ + "img/img-card-reconocer@2x.a1597480.png";